<template>
  <div class="crud">
    <div class="notification">
      <notification-message />
    </div>

    <div class="updateListUser">
      <v-btn color="red darken-1" outlined @click="openLoginWdg2">
        {{ $t("crudUser.updateListUser") }}
      </v-btn>
      <div class="login-wdg2">
        <login-wdg-2
          v-if="showLoginWdg2Card"
          @logInUser="logInUserWdg2"
          @wdg2Close="wdg2Close"
        />
      </div>
      <v-progress-circular
        v-if="loading"
        indeterminate
        color="red darken-1"
      ></v-progress-circular>
    </div>

    <!-- Start Array -->
    <div class="crudArray">
      <v-data-table
        :headers="headers"
        :items="users"
        :search="search"
        :footer-props="{ showFirstLastPage: true }"
        sort-by="lastName"
      >
        <template v-slot:[`item.types`]="{ item }">
          <span v-for="type in item.types" :key="type + 'A'">
            <v-chip class="mr-1" outlined>{{ type }}</v-chip>
          </span>
        </template>

        <template v-slot:[`item.skills`]="{ item }">
          <div v-for="skill in item.skills" :key="skill + 'A'">
            <span>{{ skill.title }}</span>
          </div>
        </template>

        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>{{ $t("crudUser.title") }}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-text-field
              id="search-user"
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('crudUser.searchUser')"
              single-line
              hide-details
              color="grey"
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  id="button-new-user"
                  color="red darken-1"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ $t("crudUser.new") }}
                </v-btn>
              </template>
              <!-- Start Form -->
              <v-card v-if="editedItem">
                <v-form ref="form" v-model="valid">
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="6">
                          <v-text-field
                            id="user-firstName"
                            v-model="editedItem.firstName"
                            :label="$t('crudUser.firstNameUser')"
                            :rules="inputText"
                            required
                            color="grey"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            id="user-lastName"
                            v-model="editedItem.lastName"
                            :label="$t('crudUser.lastNameUser')"
                            :rules="inputText"
                            required
                            color="grey"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <v-text-field
                            id="user-email"
                            v-model="editedItem.email"
                            :label="$t('crudUser.emailUser')"
                            :rules="inputEmail"
                            required
                            color="grey"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-autocomplete
                            id="user-locationId"
                            v-model="editedItem.locationId"
                            :items="locations"
                            item-value="id"
                            item-text="city"
                            :label="$t('crudUser.locationUser')"
                            :rules="emptyField"
                            required
                            persistent-hint
                            single-line
                            color="grey"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <v-select
                            id="user-type"
                            v-model="editedItem.types"
                            :items="$enumUserType"
                            :label="$t('crudUser.typesUser')"
                            required
                            multiple
                            chips
                            color="grey"
                          />
                        </v-col>
                        <v-col cols="6">
                          <v-autocomplete
                            id="user-company"
                            v-model="editedItem.company"
                            :items="$enumUserCompany"
                            item-value="value"
                            item-text="text"
                            :label="$t('crudUser.companyUser')"
                            :rules="emptyField"
                            required
                            persistent-hint
                            single-line
                            color="grey"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            id="user-skills"
                            v-model="editedItem.skills"
                            :label="$t('crudUser.skillsUser')"
                            required
                            color="grey"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <div>
                            <image-to-base64
                              class="upload-btn"
                              :maxSize="150 / 1024"
                              :previewImage="previewImage"
                              :preview="editedItem.imagePath"
                              @file-info="reciveFileInfo"
                              @size-error="sizeError"
                              @type-error="typeError"
                            >
                            </image-to-base64>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="7"></v-col>
                        <v-col cols="5">
                          <p>
                            <i>{{ $t("crudUser.required") }}</i>
                          </p>
                        </v-col>
                      </v-row>
                      <v-row>
                        <!-- Start Error messages from the BackEnd -->
                        <v-card-text v-if="errors">
                          <ul class="errors">
                            <li v-for="e in errorBackend" :key="e.valueE">
                              {{ e.valueE }}
                            </li>
                          </ul>
                        </v-card-text>
                        <!-- End Error messages from the BackEnd -->
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="close">
                      {{ $t("crudUser.cancel") }}
                    </v-btn>
                    <v-btn
                      id="button-save-user"
                      color="red darken-1"
                      text
                      @click="save"
                      :disabled="!valid"
                    >
                      {{ $t("crudUser.save") }}
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
              <!-- End Form -->
            </v-dialog>
            <!-- Start Dialog Delete -->
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card v-if="editedItem" class="card-delete">
                <v-card-title class="headline">{{
                  $t("crudUser.confirmDelete")
                }}</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="F44336" text @click="closeDelete">{{
                    $t("crudUser.cancel")
                  }}</v-btn>
                  <v-btn
                    id="button-delete-user"
                    color="F44336"
                    text
                    @click="deleteItemConfirm"
                    >{{ $t("crudUser.ok") }}</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- End Dialog Delete -->
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="button-update-user" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <!-- <v-icon small class="button-delete-user" @click="deleteItem(item)">
            mdi-delete
          </v-icon> -->
        </template>
        <template v-slot:no-data>
          {{ $t("crudUser.noData") }}
        </template>
      </v-data-table>
    </div>
    <!-- End Array -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import NotificationMessage from "@/components/components-base/notification/NotificationMessage.vue";
import i18n from "@/i18n";
import base64ToImage from "@/components/components-base/image/base64ToImage.vue";
import imageToBase64 from "@/components/components-base/image/imageToBase64.vue";
import LoginWdg2 from "@/components/components-base/LoginWdg2.vue";

export default {
  components: {
    NotificationMessage,
    imageToBase64,
    base64ToImage,
    LoginWdg2,
  },
  data: () => ({
    fileInfo: null,
    previewImage: true,
    search: "",
    dialog: false,
    dialogDelete: false,
    errors: false,
    headers: [
      {
        text: i18n.t("crudUser.hFirstName"),
        value: "firstName",
        sortable: true,
      },
      { text: i18n.t("crudUser.hLastName"), value: "lastName", sortable: true },
      { text: i18n.t("crudUser.hEmail"), value: "email", sortable: true },
      { text: i18n.t("crudUser.hTypes"), value: "types", sortable: true },
      { text: i18n.t("crudUser.hCompany"), value: "company", sortable: true },
      { text: i18n.t("crudUser.hSkills"), value: "skills", sortable: true },
      {
        text: i18n.t("crudUser.hActions"),
        value: "actions",
        align: "center",
        sortable: false,
      },
    ],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
    showLoginWdg2Card: false,
    loading: false,
    valid: true,
    emptyField: [(v) => !!v || i18n.t("errorFrontEnd.requiredField")],
    inputText: [
      (v) => !!v || i18n.t("errorFrontEnd.requiredField"),
      (v) =>
        /^[ A-Za-z0-9/-]*$/.test(v) ||
        i18n.t("errorFrontEnd.specialCharacters"),
    ],
    inputEmail: [
      (v) => !!v || i18n.t("errorFrontEnd.requiredField"),
      (v) =>
        /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v
        ) || i18n.t("errorFrontEnd.invalidEmail"),
    ],
    inputPassword: [
      (v) => !!v || i18n.t("errorFrontEnd.requiredField"),
      (v) =>
        /^(?=.*[a-z])(?=.*[A-ZÀ-ȕ])(?=.*[0-9])(?=.*[\(\)\,\-\_\.\, !@#\$%\^&\*])/.test(
          v
        ) || i18n.t("errorFrontEnd.invalidPassword"),
      (v) => (v && v.length >= 8) || i18n.t("errorFrontEnd.atLeastCharacters"),
    ],
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? i18n.t("crudUser.newUser")
        : i18n.t("crudUser.updateUser");
    },
    ...mapGetters("userModule", { users: "getUsers" }),
    ...mapGetters("locationModule", { locations: "getLocations" }),
    ...mapGetters("notificationModule", { errorBackend: "getErrorBackend" }),
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  mounted() {},
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("userModule", [
      "loadUsers",
      "addUser",
      "editUser",
      "deleteUser",
      "fetchUsersDG2",
    ]),
    ...mapActions("locationModule", ["loadLocations"]),
    ...mapActions("notificationModule", [
      "showNotification",
      "emptyErrorMessages",
    ]),
    initialize() {
      this.loadLocations();
      this.loadUsers();
    },
    editItem(item) {
      this.emptyErrorMessages();
      this.errors = false;
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
      this.fileInfo = null;
    },
    deleteItemConfirm() {
      this.deleteUser(this.editedItem);
      this.closeDelete();
    },
    close() {
      this.emptyErrorMessages();
      this.errors = false;
      this.dialog = false;
      this.fileInfo = null;
      this.editedItem.imagePath = null;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.$refs.form.reset();
    },
    closeDelete() {
      this.dialogDelete = false;
      this.fileInfo = null;
      this.editedItem.imagePath = null;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.$refs.form.reset();
    },
    save() {
      this.emptyErrorMessages();
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          this.editUser(this.editedItem).then((e) => {
            if (this.errorBackend.length === 0) {
              this.close();
            } else {
              this.dialog = true;
              this.errors = true;
            }
          });
        } else {
          this.addUser(this.editedItem).then((e) => {
            if (this.errorBackend.length === 0) {
              this.close();
            } else {
              this.dialog = true;
              this.errors = true;
            }
          });
        }
      }
    },
    // open the card to let the user login to webservice DG2
    openLoginWdg2() {
      this.showLoginWdg2Card = true;
    },
    // fetch courses from webservice DG2
    async logInUserWdg2(value) {
      this.showLoginWdg2Card = false;
      this.loading = true;
      await this.fetchUsersDG2({ logInUser: value });
      this.loading = false;
      await this.loadUsers();
    },
    // close the card for the login to webservice DG2
    wdg2Close(value) {
      this.showLoginWdg2Card = value;
    },
    reciveFileInfo(v) {
      this.fileInfo = v;
      v && this.uploadImage();
    },
    sizeError(v) {
      v && alert(i18n.t("imageToBase64.errorImageSize"));
    },
    typeError(v) {
      v && alert(i18n.t("imageToBase64.errorImageFormat"));
    },
    uploadImage() {
      if (this.fileInfo) {
        this.editedItem.imagePath = this.fileInfo.base64;
      }
    },
  },
};
</script>

<style>
.crud {
  width: 100%;
}

.crudArray {
  margin: 3rem auto;
  width: 90%;
}

.notification {
  width: 100%;
  position: absolute;
  padding: 0 1.5rem;
}

.login-wdg2 {
  position: absolute;
  width: 30%;
  z-index: 3;
}

.errors {
  color: red;
  list-style-type: none;
}

.updateListUser {
  display: flex;
  justify-content: center;
  padding: 2rem 0 0 0;
}
</style>
